module.exports = __webpack_public_path__ + "static/media/join-in-img3-1.174cb2a7.png";